import React from 'react'
import Footer from '../Footer'
import EducationCLRHS4 from '../EducationCLRHS4'

function CLRHS4() {
    window.scrollTo(0,0);
    return (
        <div>
            <EducationCLRHS4/>
            <Footer/>
        </div>
    )
}

export default CLRHS4
